import React from 'react'

export default function LoadingSpinner() {
  return (
    <div className='lds-ring'>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/loader.js